// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3GTWS","name":"ConsentHeader_name__3EifN","birthday":"ConsentHeader_birthday__3jILw","skeleton":"ConsentHeader_skeleton__2lLog"};